import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../../../components/Layout/Layout';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import LcLoading from '../../../components/Generic/LcLoading';
import LcInfiniteTable from "../../../components/Data/LcInfiniteTable";
import { LCTechService } from "../../../services/LCTechService";
import LcIconLink from '../../../components/Generic/LcIconLink';
import SideModal from '../../../components/Layout/SideModal/SideModal';
import { useSnackbar } from 'notistack';
import { PPModal } from 'processor-plataform-ui';
import "./index.css";
import ReactHtmlParser from 'react-html-parser';
import LCDashboard from '../../../components/Data/Dashboard/LCDashboard';
import GaugeChartCore from '../../../components/Layout/Dashboard/gaugeChartCore';
import IconValue from '../../../components/Layout/Dashboard/IconValue';
import { PiHeadset, PiUsers } from 'react-icons/pi';
import { RiDatabase2Line } from 'react-icons/ri';
//Img Fluxo
import ImgFluxo from '../../../assets/images/Fluxos/csp.png';
import history from '../../../history';

import { SaaSUser, SaasUserService } from '../../../services/SaasUserService';
//import { SaasUserService } from "../../../services/SaasUserService.1";
import PivotTableWebix from '../../../components/webix';
import HeyHoNewRequest, { FormDataHeyho } from '../../../components/Generic/HeyHoNewRequest';

interface SecureScore {
    currentScore: number,
    maxScore: number,
    licenseCount: number,
    servicesCount: number,
    servicesList: string,
    secureScoreCategoryList: ScoreCategoryList[]
}

interface ScoreCategoryList {
    category: string,
    count: number,
    scoreDetailList: ScoreDetailList[]
}

interface ScoreDetailList {
    description: string,
    scorePercent: number,
    implementationStatus: string
}

const defaultCategories = [
    { category: 'apps', count: 0, color: '#E273C5', icon: 'lci lci-device-tablet' },
    { category: 'data', count: 0, color: '#8684EF', icon: 'lci lci-puzzle' },
    { category: 'identity', count: 0, color: '#F2CB4F', icon: 'lci lci-identification' },
    { category: 'device', count: 0, color: '#8684EF', icon: 'lci lci-puzzle' },
];

const getColor = (category: string) => {
    const catData = defaultCategories.find(cat => cat.category == category);
    return catData ? catData.color : '#8684EF';
}

const getIcon = (category: string) => {
    const catData = defaultCategories.find(cat => cat.category == category);
    return catData ? catData.icon : 'lci lci-puzzle';
}

const mergeDataWithDefaults = (data) => {
    return defaultCategories.map(def => {
        const fromData = data.find(item => item.category == def.category);
        return fromData ? fromData : def;
    });
}

const CSPSecurityScore: React.FC = (props: any) => {
    const SecureDafeult: SecureScore = {
        currentScore: 0,
        maxScore: 0,
        licenseCount: 0,
        servicesCount: 0,
        servicesList: '',
        secureScoreCategoryList: []
    }

    const dispatch = useDispatch();
    const user = useSelector<RootState, UserState>(state => state.user);
    const ServiceInstance = new LCTechService({});
    const SaaS_Service = new SaasUserService(props)
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isLoadingUsers, setIsLoadingUsers] = useState<boolean>(true);
    const [scorePercent, setScorePercent] = useState<number>(0);
    const [implementationStatus, setImplementationStatus] = useState<string>('');
    const [showImplementationStatus, setShowImplementationStatus] = useState<boolean>(false);
    const [modalVisibleHeyHoCall, setModalVisibleHeyHoCall] = useState<boolean>(false);
    const [secureScore, setSecureScore] = useState<SecureScore>(SecureDafeult);
    const [selectedCategoryDetailList, setSelectedCategoryDetailList] = useState<any[]>([]);
    const [filteredCategoryDetailList, setFilteredCategoryDetailList] = useState<any[]>([]);
    const [cards, setCards] = useState<any[]>();
    const [cardBackgroundColors, setCardBackgroundColors] = useState<any[]>([]);
    const [filter, setFilter] = useState<{ size: number, term: string, column: string, direction: string }>({ size: 20, term: "", column: "description", direction: "asc" });
    const [formData, setFormData] = useState<FormDataHeyho>({ title: '', description: '', gtmType: 0 });
    const { enqueueSnackbar } = useSnackbar();
    const [showFluxoCSP, setShowFluxoCSP] = useState<boolean>(false);
    const [formattedData, setFormattedData] = useState<UserData[]>();

    type MergedDataItem = {
        category: string;
        count: number;
        color: string;
        icon: string;
    };

    const createSecureCards = (mergedData: MergedDataItem[]) => {
        return mergedData.map(item => {
            let colValue;
            let rowValue;
            let bgColor;
            let fontColor;

            switch (item.category) {
                case 'apps':
                    colValue = 7;
                    rowValue = 3;
                    break;
                case 'data':
                    colValue = 10;
                    rowValue = 4;
                    break;
                case 'identity':
                    colValue = 10;
                    rowValue = 3;
                    break;
                case 'device':
                    colValue = 7;
                    rowValue = 4;
                    break;
                default:
                    colValue = 5;
                    rowValue = 4;
            }

            return {
                bgColor: bgColor,
                fontColor: fontColor,
                type: 'Custom',
                position: {
                    row: rowValue,
                    col: colValue,
                    RowSpan: 1,
                    ColSpan: 3,
                },
                showFocusButton: true,
                title: () => { return item.category.charAt(0).toUpperCase() + item.category.slice(1) },
                customContentRender: (focused?: boolean) => {
                    if (focused) {
                        handleFocus(item);
                        return (
                            <div className="table-card">
                                <LcInfiniteTable
                                    loading={isLoading}
                                    columns={columns}
                                    status={getStatus}
                                    rows={filteredCategoryDetailList}
                                    loadMore={() => undefined}
                                    size={filteredCategoryDetailList.length}
                                    filter={_filterAdvanced}
                                    functionGeneric={_functionGeneric}
                                    onSortChange={onSortChange}
                                    hidePagination={true}
                                    density='low'
                                    tooltipContentColumn='scorePercent'
                                />
                            </div>
                        )
                    } else {

                        let content;
                        const categoryColor = getColor(item.category);

                        switch (item.category) {
                            case 'data':
                                content = (
                                    <div className="big-number-content">
                                        <RiDatabase2Line color={categoryColor} className="big-number-icon" />
                                        <div className="big-number-value" style={{ color: categoryColor }}>
                                            {item.count.toString()}
                                        </div>
                                    </div>
                                );
                                break;
                            default:
                                const backgroundColorObj = cardBackgroundColors?.find(x => x.name == item.category);
                                const backgroundColorValue = backgroundColorObj ? backgroundColorObj.color : 'white';
                                content = (
                                    <IconValue
                                        icon={getIcon(item.category)}
                                        value={item.count.toString()}
                                        color={getColor(item.category)}
                                        backgroundColor={backgroundColorValue}>
                                    </IconValue>
                                );
                                break;
                        }

                        return (
                            <div className={`${item.count == 0 ? "no-content" : ""}`}>
                                {content}
                            </div>
                        );
                    }
                }
            }
        });
    }

    const getInitialCards = () => {
        return [
            {
                type: 'Custom', position: { row: 1, col: 1, RowSpan: 3, ColSpan: 6 },
                showFocusButton: false,
                title: () => "Score de segurança de suas subscrições",
                ticketButtonLabel: "Abrir chamado",
                ticketButton: () => { return <PiHeadset onClick={() => { createTicket() }} /> },
                infoContent: () => {
                    return <span>Seu score é de <b>{Math.round(((secureScore?.currentScore * 100) / secureScore?.maxScore) || 100)}%</b></span>
                },
                customContentRender: (focused?: boolean) => {
                    return (
                        <GaugeChartCore
                            title={`${(Math.round(secureScore?.currentScore) || 0)} pontos de ${(secureScore?.maxScore || 0)} possíveis `}
                            value={((secureScore?.currentScore * 100) / secureScore?.maxScore) || 100}
                            style={{ maxHeight: '300px' }}
                        />
                    )
                }
            },
            {
                type: 'Custom',
                position: { row: 4, col: 1, RowSpan: 1, ColSpan: 6 },
                title: () => {
                    return <>{
                        <div className="lc-title ellipsis">Alertas de fraude</div>
                    }</>
                },
                customContentRender: () => {
                    return <div style={{ width: '100%', height: '100%' }} >
                        <IconValue title={'Microsoft 365 suite'} icon="lci lci-exclamation" value={0} unity="" color="rgb(0, 128, 0)"
                            maximumFractionDigits={2}
                            minimumFractionDigits={2}
                            noDataLabel="Sem fraudes no período."
                            formatValue={true}></IconValue>
                    </div>
                }
            },
            {
                type: 'Custom', position: { row: 1, col: 7, RowSpan: 2, ColSpan: 3 },
                showFocusButton: true,
                title: () => "Total de usuários",
                customContentRender: (focused?: boolean) => {
                    if (focused) {
                        return (
                            <div style={{ marginTop: '3rem' }}>
                                {formattedData && formattedData.length > 0 && (
                                    <PivotTableWebix
                                        idView={'dataPivot'}
                                        key={'dataPivot'}
                                        data={formattedData}
                                        fields={[
                                            { id: 'displayName', value: "Nome", type: "text" },
                                            { id: 'userPrincipalName', value: "E-mail", type: "text" },
                                            { id: 'licences', value: "Licença", type: "text" }
                                        ]}
                                        structure={{
                                            rows: ["displayName", "userPrincipalName", "licences"],
                                            filters: [{ name: "displayName" }, { name: "licences" }]
                                        }}
                                    />

                                )}
                            </div>
                        );
                    } else {
                        return (<>
                            {isLoadingUsers ? <LcLoading loading={isLoadingUsers} label="Carregando..." > </LcLoading> :
                                <div className="big-number-content">
                                    <PiUsers title="Total de usuários" color="#8684EF" className="big-number-icon" />
                                    <div className="big-number-value" style={{ color: "#8684EF" }} >
                                        {formattedData ? formattedData.length : 0}
                                    </div>
                                </div>}
                        </>);
                    }
                }
            },
            {
                type: 'Custom', position: { row: 1, col: 10, RowSpan: 2, ColSpan: 3 },
                showFocusButton: false,
                ticketButtonLabel: "Abrir chamado",
                ticketButton: () => { return <PiHeadset onClick={() => { createTicket() }} /> },
                title: () => "Solicitação de evolução",
                customContentRender: (focused?: boolean) => {
                    return (
                        <>
                            <span onClick={() => { createTicket() }} className="link" style={{ textAlign: "center", paddingBottom: "10px" }}>
                                <i className="lci lci-shield-exclamation" style={{ color: "#F2CB4F", fontSize: "4vw" }} ></i>
                            </span>

                            <span className="lc-subtitle">Existem oportunidades de evolução em seu ambiente. Clique <span className="link" onClick={() => { createTicket() }}><b>aqui</b></span> para fazermos proposições de avanço considerando as melhores práticas listadas.</span>
                        </>

                    )
                }
            }
        ]
    }

    function clearState() {
        setCardBackgroundColors([]);
        setSecureScore(SecureDafeult);
    }

    useEffect(() => {
        clearState();
        loadUsers().then(item => {
            ServiceInstance.GetSecureScores()
                .then(response => {
                    let _backgroundColors = response.data.secureScoreCategoryList?.map((item: any, index: number) => {
                        return { name: item.category, color: 'white' }
                    });

                    setCardBackgroundColors(_backgroundColors);
                    setSecureScore(response.data);
                    setIsLoading(false);
                })
                .catch(error => {
                    setShowFluxoCSP(true)
                    setIsLoading(false);
                    if (error.response.data.message && typeof error.response.data.message == 'string') {
                        enqueueSnackbar(error.response.data.message, {
                            variant: 'error',
                            preventDuplicate: true,
                            persist: false,
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'right',
                            },
                        })
                        return
                    }
                });
        });

    }, [user.ClientGroupSelected, user.refreshFlag]);

    useEffect(() => {
        var filtered = selectedCategoryDetailList.filter((p: any) =>
            filter.term == '' ||
            p.description.toLowerCase().indexOf(filter.term) > -1
        )
            .sort((a: any, b: any) => {
                if (filter.direction == 'desc') return (a[filter.column] > b[filter.column]) ? 1 : -1;
                else return (a[filter.column] > b[filter.column]) ? -1 : 1;
            });
        setFilteredCategoryDetailList(filtered);
    }, [filter]);

    const columns = [
        {
            field: 'description', headerName: 'Oportunidades de evolução na segurança de seu ambiente', width: "90%", expandable: true, sort: false,
            renderCell: (row: any) => {
                return (
                    ReactHtmlParser(row.description)
                )
            }
        },
        {
            field: 'scorePercent', headerName: '% Score', width: "6%", align: 'center',
            renderCell: (row: any) => {
                return (
                    <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
                        {Math.round(row.scorePercent)}
                    </div>
                )
            }
        },
        {
            field: 'implementationStatus', width: "2%", overflow: "visible", sort: false,
            renderCell: (row: any) => {
                return (
                    <>
                        <LcIconLink
                            icon="lci lci-document-text"
                            tooltip="Status da implementação"
                            tooltipPosition='right'
                            onClick={() => {
                                setImplementationStatus(row.implementationStatus);
                                setScorePercent(Math.round(row.scorePercent));
                                setShowImplementationStatus(true);
                            }}
                        />
                    </>
                )
            }
        }
    ];

    const getStatus = (row: { scorePercent: number }): string => {
        if (row.scorePercent === 0) {
            return "danger";
        } else if (row.scorePercent > 0 && row.scorePercent < 100) {
            return "warning";
        } else if (row.scorePercent === 100) {
            return "success";
        } else {
            return "primary";
        }
    };

    const _filterAdvanced = {
        fields: [{ label: 'Pesquisar', name: 'term', type: 'text' },],
        onChange: (_filter: any, size: number) => setFilter({ ...filter, size: size, term: _filter[0].value.toLowerCase() })
    }

    const onSortChange = (sortData: any) => {
        const { sort, size } = sortData;
        setFilter({ ...filter, column: sort.column, direction: sort.direction, size: size })
    };

    const openCategory = (item: any) => {
        let _scoreDetail = item.scoreDetailList.map((scoreDetail: any, index: number) => {
            return { ...scoreDetail, id: index };
        })
            .sort((a, b) => {
                if (a.scorePercent > b.scorePercent) { return 1 } else { return -1 }
            });
        setSelectedCategoryDetailList(_scoreDetail);
        setFilteredCategoryDetailList(_scoreDetail);
    }

    const changeBackgroundColors = (category: string) => {
        let _backgroundColors = cardBackgroundColors.map((item: any) => {
            if (item.name == category) {
                return { ...item, color: '#dde0ed' }
            } else {
                return { ...item, color: 'white' }
            }
        });
        setCardBackgroundColors(_backgroundColors);
    }

    const _functionGeneric = [
        {
            title: 'Abrir Chamado',
            icon: 'ppi ppi-headset',
            tooltip: "Abrir Chamado",
            func: () => { createTicket() }
        }
    ];


    const closeButton = {
        show: true,
        onClose: () => setModalVisibleHeyHoCall(false)
    };

    const createTicket = () => {
        setFormData({
            title: `Melhorias no contexto de segurança.`,
            description: `Olá, gostaria de sugestões de melhoria no contexto de segurança do ambiente da ${user.ClientGroupSelectedDescription}.`,
            gtmType: 9
        });
        setModalVisibleHeyHoCall(true);
    }

    const infoAnchorRef = useRef<any>(null);
    const scrollToInfoAnchor = () => infoAnchorRef.current.scrollIntoView({ behavior: "smooth" });
    const [datailsView, setDatailsView] = useState<any>(false)
    const [categoryItem, setCategoryItem] = useState<any>()
    const [itemDatail, setItemDatail] = useState<any>()

    const handleClickDetails = (item, category: any) => {
        if (item && item.category == category) {
            setCardBackgroundColors([]);
            setSelectedCategoryDetailList([]);
            setFilteredCategoryDetailList([]);
            let _scoreDetail = item.scoreDetailList.map((scoreDetail: any, index: number) => {
                return { ...scoreDetail, id: index };
            })
                .sort((a, b) => {
                    if (a.scorePercent > b.scorePercent) { return 1 } else { return -1 }
                });

            let _backgroundColors = cardBackgroundColors.map((item: any) => {
                if (item.name == item.category) {
                    return { ...item, color: '#dde0ed' }
                } else {
                    return { ...item, color: 'white' }
                }
            });
            setCardBackgroundColors(_backgroundColors);
            setSelectedCategoryDetailList(_scoreDetail);
            setFilteredCategoryDetailList(_scoreDetail);
        }
    }

    interface UserData {
        displayName: string;
        userPrincipalName: string;
        licences: string;
    }

    const loadUsers = async () => {
        setIsLoadingUsers(true);
        try {
            var expandedData = await SaaS_Service
                .GetUserServices();

        /* const originalData = resultUsers && resultUsers.data;
            const expandedData: UserData[] = [];
            originalData.forEach(user => {
                try {
                    if (!user.displayName.includes("Inativo") && !user.displayName.includes("Desligado")) {
                        if (user.licences && user.licences.trim() != "") {
                            const licencesArray = user.licences.split(',');
                            licencesArray.forEach(licence => {
                                expandedData.push({
                                    displayName: user.displayName,
                                    userPrincipalName: user.userPrincipalName,
                                    licences: licence.trim()
                                });
                            });
                        } else {
                            // Adicionando uma entrada com licenças em branco
                            expandedData.push({
                                displayName: user.displayName,
                                userPrincipalName: user.userPrincipalName,
                                licences: " "
                            });
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            });
            */
            setFormattedData(expandedData.pivot);

        } catch (e) {
            console.error(e);
        }
        setIsLoadingUsers(false); 
    }

    const handleFocus = (focusedItem) => {
        setItemDatail(focusedItem);
        setCategoryItem(focusedItem.category);
    }

    const loadSecure = async () => {
        if (secureScore && secureScore.secureScoreCategoryList) {
            const mergedData = mergeDataWithDefaults(secureScore.secureScoreCategoryList);
            const secureCards = createSecureCards(mergedData);
            const initialCards = getInitialCards();

            const cardAs = [...initialCards, ...secureCards]
            setCards(cardAs)
        }
    }
    useEffect(() => {
        loadSecure();
    }, [secureScore, filteredCategoryDetailList]);

    useEffect(() => {
        if (itemDatail && categoryItem)
            handleClickDetails(itemDatail, categoryItem)
    }, [itemDatail, categoryItem]);

    return (
        <Layout pageTitle="Security Score">
            {
                showFluxoCSP ?
                    <div className="lc-segment">
                        <div className="body">
                            Para utilizar as funcionalidades de Tech - EA/EAS, é necessário
                            fornecer e/ou atualizar as credenciais de acesso conforme os passos abaixo. . Caso precise de ajuda abra uma requisição, clicando <span className="link text-link" onClick={() => { history.push('/Chamados'); dispatch({ type: 'MENU_NEW_REQUEST', payload: true }) }}>aqui</span>, e teremos o prazer em atender.
                            <img src={ImgFluxo} width="100%" alt="Procedimento" />
                        </div>
                    </div>
                    :
                    <LcLoading loading={isLoading && isLoadingUsers} label="Carregando..." >
                        {cards && <LCDashboard cards={cards} rightSidePanel={{
                            title: '',
                            content: () => undefined,
                            pinned: false,
                            show: false
                        }}
                        />}
                        <SideModal header={"Detalhes"} onClose={() => { setShowImplementationStatus(false); setImplementationStatus(''); }} visible={showImplementationStatus} >
                            <div className="sideModalReport">
                                <div className="rowContent">
                                    {
                                        ReactHtmlParser(
                                            scorePercent > 0
                                                ? (implementationStatus ? implementationStatus : 'O fornecedor não disponibilizou mais informações sobre o status dessa implementação')
                                                : 'Sem status de implementação'
                                        )
                                    }
                                </div>

                            </div>
                        </SideModal>
                        <HeyHoNewRequest formData={formData} openModal={modalVisibleHeyHoCall} onClose={() => setModalVisibleHeyHoCall(false)} needAtachmente/>
                        {/* <PPModal visible={modalVisibleHeyHoCall} title="Abertura de chamado" onClose={() => setModalVisibleHeyHoCall(false)}>
                            <HeyhoCall formData={formData} closeButton={closeButton}></HeyhoCall>
                        </PPModal> */}
                    </LcLoading>
            }
        </Layout>
    );
}

export default CSPSecurityScore;